import getZipCodeSchema from './getZipCodeSchema'
export * from './getZipCodeSchema'
export default getZipCodeSchema
